module.exports = __webpack_public_path__ + "media/images/snack-logo-black_new-11de70f4e3493a38f04ca38a8b2353ab.jpeg";